export default __webpack_public_path__ + "static/media/celo-punks.94181f72.jpeg";